import { useFetchCalendarAccountsQuery, selectIds } from 'features/calendar_connections'

import { Container as ProvidersContainer } from './integration_card'
import { CalendarAccount } from './integration_provider'

export const ActiveCalendarConnections = () => {
  const { data } = useFetchCalendarAccountsQuery()
  const connectionIds = selectIds(data)

  return (
    <ProvidersContainer>
      {connectionIds.map((id) => <CalendarAccount key={id} id={id} />)}
    </ProvidersContainer>
  )
}
